import {invert} from 'underscore';

import {AdcConjugationMethod} from 'graphql-client/__generated/graphqlGlobalTypes';

/**
 * Display names of the conjugation methods, which registration tables store in place of the enum values.
 * Listed in the order the Conjugation method dropdown offers them.
 */
export const CONJUGATION_METHOD_TO_DISPLAY_NAME: Record<AdcConjugationMethod, string> = {
  [AdcConjugationMethod.LYSINE_CONJUGATION]: 'Lysine conjugation',
  [AdcConjugationMethod.DISULFIDE_CONJUGATION]: 'Disulfide conjugation',
  [AdcConjugationMethod.ENGINEERED_CYSTEINE]: 'Engineered cysteine',
  [AdcConjugationMethod.NON_NATURAL_AMINO_ACID]: 'Non-natural amino acid',
  [AdcConjugationMethod.ENZYMATIC_CONJUGATION]: 'Enzymatic conjugation',
  [AdcConjugationMethod.GLYCAN_REMODELING]: 'Glycan remodeling',
  [AdcConjugationMethod.PERIODATE_OXIDATION]: 'Periodate oxidation',
  [AdcConjugationMethod.METABOLIC_GLYCAN_LABELING]: 'Metabolic glycan labeling',
};

export const CONJUGATION_METHOD_DISPLAY_NAME_TO_ENUM: Partial<Record<string, AdcConjugationMethod>> = invert(
  CONJUGATION_METHOD_TO_DISPLAY_NAME
);

export const CONJUGATION_METHOD_OPTIONS: Array<string> = Object.values(CONJUGATION_METHOD_TO_DISPLAY_NAME);
